var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/app-footer.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-ffad2c62!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/app-footer.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/AppFooter.vue
// module id = 1283
// module chunks = 1